import toast from 'react-hot-toast';
import moment from 'moment';
import {
  ROLE,
  GOOGLE_MAP_MAX_LAT,
  GOOGLE_MAP_MAX_LNG,
  ESCAPE_TARGET,
  LICENSE_CAPACITY_STATUS,
  CANSUKE_RESULT,
} from './constants';
import messages from './i18n';
import config from '../config';

window.apiToken = {}; // 全体でキャンセルトークンを管理する

const { locale, cansuke } = config;
const i18nMessages = messages[locale];

export const consoleNormalLog = params => {
  console.log(params); // eslint-disable-line no-console
};

export const consolelog = params => {
  const DEBUG = process.env.DEBUG || 0;
  // console.log('process.env', process.env);
  if (DEBUG && process.env.NODE_ENV === 'development') {
    // NOTE DEBUGをONにするとAPIの呼び出しをconsole.logに出力する
    console.log(params); // eslint-disable-line no-console
  }
};

export const addCancelToken = (cancelTokenKey, token) => {
  window.apiToken[cancelTokenKey] = token;
};

export const delCancelToken = cancelTokenKey => {
  delete window.apiToken[cancelTokenKey];
};

export const checkCancelToken = cancelTokenKey =>
  Object.keys(window.apiToken).indexOf(cancelTokenKey) !== -1;

export const cancelAllApi = () => {
  Object.keys(window.apiToken).forEach(key => {
    const value = window.apiToken[key];
    if (value && value.source && value.source.cancel) {
      value.source.cancel();
    }
    delCancelToken(key);
  });
};

export const isRoot = role => role === ROLE.ROOT;
export const isServiceVendor = role => role === ROLE.SERVICE_VENDOR;
export const isCompanyAdmin = role => role === ROLE.COMPANY_ADMIN;
export const isCompanyGeneral = role => role === ROLE.GENERAL;
export const isAdmin = role => role === ROLE.ADMIN;
export const isGeneral = role => role === ROLE.GENERAL;
export const isGuest = role => role === ROLE.GUEST;
export const isInitialRole = role => role === ROLE.INITIAL;
export const isRootOrSp = role => isRoot(role) || isServiceVendor(role);
export const isCompanyUser = role => !isRootOrSp(role);

export const validationDate = date => {
  const result = !(
    date.match(/^\d{4}-\d{2}-\d{2}$/) && moment(date, 'YYYY-MM-DD').isValid()
  );
  return result;
};

export const validationDateTime = date => {
  const result = !(
    date.match(/^\d{4}\/\d{2}\/\d{2} \d{2}:\d{2}$/) &&
    moment(date, 'YYYY-MM-DD hh:mm').isValid()
  );
  return result;
};

export const validationLat = lat => {
  const result = !(lat >= -GOOGLE_MAP_MAX_LAT && lat <= GOOGLE_MAP_MAX_LAT);
  return result;
};

export const validationLng = lng => {
  const result = !(lng >= -GOOGLE_MAP_MAX_LNG && lng <= GOOGLE_MAP_MAX_LNG);
  return result;
};

export const validationCharacterLimit = (value, limit) => {
  const result = value !== null && value !== '' && value.length > limit;
  return result;
};

export const validationUuidEasy = value =>
  // 厳密なチェックではなく簡易的なチェックを行う
  !value.match(
    /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/,
  );

export const isInteger = value => {
  // unsigned int の正の最大値チェック
  const n = Number(value);
  return n >= 0 && n <= 2147483647;
};

export const validationNumeric = value => {
  const str = `${value}`;
  const result = !isInteger(str) || !str.match(/^[0-9]+$/);
  return result;
};

export const convertISOFormatToDate = date => {
  const wkDate = moment(date).tz('Asia/Tokyo');
  const result = (wkDate.isValid() && wkDate.format('YYYY/MM/DD HH:mm')) || '';
  return result;
};

export const convertISOFormatToOnlyDate = date => {
  const wkDate = moment(date).tz('Asia/Tokyo');
  const result = (wkDate.isValid() && wkDate.format('YYYY/MM/DD')) || '';
  return result;
};

export const convertDateToISOFormat = date => {
  const wkDate = moment(date, 'YYYY/MM/DD HH:mm');
  const result = (wkDate.isValid() && wkDate.format('YYYY-MM-DD HH:mm')) || '';
  return result;
};

export const convertUnixtTimeToDateTime = timestamp => {
  const wkDate =
    (timestamp && moment(Number(timestamp)).format('YYYY/MM/DD HH:mm')) || '';
  return wkDate;
};

export const convertUnixtTimeToDateTimeSecond = timestamp => {
  const wkDate =
    (timestamp && moment(Number(timestamp)).format('YYYY/MM/DD HH:mm:ss')) ||
    '';
  return wkDate;
};

export const convertUnixtTimeToDate = timestamp => {
  const wkDate =
    (timestamp && moment(Number(timestamp)).format('YYYY/MM/DD')) || '';
  return wkDate;
};

export const convertDateToUnixtTime = date => {
  const wkTimestamp =
    (date && moment(date, 'YYYY/MM/DD HH:mm').valueOf().toString()) || '';
  return wkTimestamp;
};

export const convertDateToISO8601 = date => {
  const wkTimestamp = (date && moment(date).toISOString()) || '';
  return wkTimestamp;
};

export const addEscapeCharacter = value => {
  const escapeTarget = ESCAPE_TARGET.reduce(
    (previous, current) => `${previous}|${current}`,
  );
  const regex = new RegExp(escapeTarget, 'g');
  const result = (value && value.replace(regex, '\\$&')) || '';
  return result;
};

export const convertSearchOptions = searchOptions => {
  const newSearchOptions = { ...searchOptions };
  Object.keys(newSearchOptions).map(key => {
    newSearchOptions[key] =
      ((key === 'recordedDateFrom' || key === 'recordedDateTo') &&
        convertDateToUnixtTime(searchOptions[key])) ||
      ((key === 'partialOperatorName' ||
        key === 'partialDeviceNickname' ||
        key === 'companyCode' ||
        key === 'companyName') &&
        addEscapeCharacter(searchOptions[key])) ||
      searchOptions[key];
    return true;
  });
  return newSearchOptions;
};

export const validationSearchParams = params => {
  const key = Object.keys(params)[0];
  const value = Object.values(params)[0];
  switch (key) {
    case 'recordedDateFrom': {
      const result = validationDateTime(value) && value !== '';
      return { recordedDateFrom: result };
    }
    case 'recordedDateTo': {
      const result = validationDateTime(value) && value !== '';
      return { recordedDateTo: result };
    }
    default: {
      return {};
    }
  }
};

export const validationCompany = params => {
  const key = Object.keys(params)[0];
  const value = Object.values(params)[0];
  switch (key) {
    case 'lat': {
      const result = value !== null && value !== '' && validationLat(value);
      return { lat: result };
    }
    case 'lng': {
      const result = value !== null && value !== '' && validationLng(value);
      return { lng: result };
    }
    case 'companyCode': {
      const result = validationCharacterLimit(value, 255);
      return { companyCode: result };
    }
    default: {
      return {};
    }
  }
};

export const validationDevice = params => {
  const key = Object.keys(params)[0];
  const value = Object.values(params)[0];
  switch (key) {
    case 'deviceNickname': {
      const result = validationCharacterLimit(value, 255);
      return { deviceNickname: result };
    }
    default: {
      return {};
    }
  }
};

export const validationRemoteSendTextInfo = (key, work) => {
  const value = work || '';
  const trimValue = value.replace(/\s+/g, '');
  switch (key) {
    case 'title': {
      const error = trimValue.length <= 0 || trimValue.length > 255;
      return { title: { value, error } };
    }
    case 'subtitle': {
      const error = value.length > 255;
      return { subtitle: { value, error } };
    }
    case 'note': {
      const error = value.length > 255;
      return { note: { value, error } };
    }
    case 'titleSuffix': {
      return { titleSuffix: { value, error: false } };
    }
    default: {
      return {};
    }
  }
};

export const convertBytes = bytes => {
  if (!Number.isFinite(bytes)) {
    return '';
  }
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const maxIndex = sizes.length - 1;
  const i =
    (bytes > 0 && parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10)) ||
    0;
  if (i === 0) {
    return `${bytes} ${sizes[i]}`;
  }

  if (i > maxIndex) {
    return `${Math.ceil(10 * (bytes / 1024 ** maxIndex)) / 10} ${
      sizes[maxIndex]
    }`;
  }
  return `${Math.ceil(10 * (bytes / 1024 ** i)) / 10} ${sizes[i]}`;
};

export const convertRole = role =>
  i18nMessages[`operator.role.status.${role}`] || 'unknown';
export const convertAccountStatus = (status, role) => {
  if (isServiceVendor(role)) {
    return i18nMessages['operator.accountStatus.sp'];
  }
  return i18nMessages[`operator.accountStatus.${status}`] || 'unknown';
};
export const convertRemoteSupportStatus = status =>
  i18nMessages[`operator.remoteSupportStatus.${status}`] || 'unknown';

export const isLicenseExceededForSP = (licenseInfo, type) => {
  switch (type) {
    case 'userLicense': {
      const result =
        (licenseInfo && licenseInfo.userLicenseLimitExceeded) || false;
      return result;
    }
    case 'storageLicense': {
      const result =
        (licenseInfo && licenseInfo.storageLicenseLimitExceeded) || false;
      return result;
    }
    case 'remoteSupportLicense': {
      const result =
        (licenseInfo && licenseInfo.remoteSupportLicenseLimitExceeded) || false;
      return result;
    }
    default: {
      return false;
    }
  }
};

export const isLicenseExceeded = (licenseInfo, type) => {
  switch (type) {
    case 'userLicense': {
      const userLicenseInfo =
        (licenseInfo && licenseInfo.userLicenseInfo) || {};
      const licenseStatus =
        (userLicenseInfo && userLicenseInfo.licenseCapacityStatus) || 0;
      const result =
        licenseStatus === LICENSE_CAPACITY_STATUS.upperLimitExceeded;
      return result;
    }
    case 'storageLicense': {
      const storageLicenseInfo =
        (licenseInfo && licenseInfo.storageLicenseInfo) || {};
      const licenseStatus =
        (storageLicenseInfo && storageLicenseInfo.licenseCapacityStatus) || 0;
      const result =
        licenseStatus === LICENSE_CAPACITY_STATUS.upperLimitExceeded;
      return result;
    }
    case 'remoteSupportLicense': {
      const remoteSupportLicenseInfo =
        (licenseInfo && licenseInfo.remoteSupportLicenseInfo) || {};
      const licenseStatus =
        (remoteSupportLicenseInfo &&
          remoteSupportLicenseInfo.licenseCapacityStatus) ||
        0;
      const result =
        licenseStatus === LICENSE_CAPACITY_STATUS.upperLimitExceeded;
      return result;
    }
    default: {
      return false;
    }
  }
};

export const licenseExceeded = (userInfo, type) => {
  const groupLicenseInfo =
    (userInfo && userInfo.groupCompaniesLicenseInfo) || {};
  const companyLicenseInfo = (userInfo && userInfo.companyLicenseInfo) || {};
  const serviceVendor =
    (userInfo && userInfo.role && isServiceVendor(userInfo.role)) || false;
  const result = serviceVendor
    ? isLicenseExceededForSP(groupLicenseInfo, type)
    : isLicenseExceeded(companyLicenseInfo, type);
  return result;
};

export const getLicenseExceededItemForSP = licenseInfo => {
  const licenseArray =
    (licenseInfo &&
      Object.keys(licenseInfo).filter(key => licenseInfo[key] === true)) ||
    [];
  return licenseArray;
};

export const getLicenseExceededItem = licenseInfo => {
  const licenseArray =
    (licenseInfo &&
      Object.keys(licenseInfo).filter(
        key =>
          licenseInfo[key].licenseCapacityStatus ===
          LICENSE_CAPACITY_STATUS.upperLimitExceeded,
      )) ||
    [];
  return licenseArray;
};

export const licenseExceededItem = userInfo => {
  const groupLicenseInfo =
    (userInfo && userInfo.groupCompaniesLicenseInfo) || {};
  const companyLicenseInfo = (userInfo && userInfo.companyLicenseInfo) || {};
  const serviceVendor =
    (userInfo && userInfo.role && isServiceVendor(userInfo.role)) || false;
  const result = serviceVendor
    ? getLicenseExceededItemForSP(groupLicenseInfo)
    : getLicenseExceededItem(companyLicenseInfo);
  return result;
};

export const getAnalysisLicenseStatus = licenseInfo => {
  const enabled = licenseInfo && licenseInfo.enabled;
  const licenseStatus = enabled
    ? licenseInfo.licenseCapacityStatus
    : LICENSE_CAPACITY_STATUS.noLicense;
  return licenseStatus;
};

const IOS = 'iOS';
const ANDROID = 'Android';
const IPAD = 'iPad';

const IOS_SUPPORT_VERSION = Number(config.iOsSupportVersion);
const ANDROID_SUPPORT_VERSION = Number(config.androidSupportVersion);
const MIN_HEIGHT = Number(config.compatibleLowerLimitHeight);

// user agent解析(簡易版)
const parse = userAgent => {
  const ua = userAgent.toLowerCase();
  if (ua.indexOf('iphone') >= 0) {
    const array = /os ([\d_]+)/.exec(ua);
    return {
      os: {
        device: 'iPhone',
        family: IOS,
        version: array && array[1] ? array[1].split('_').join('.') : '',
      },
    };
  }

  if (ua.indexOf('ipad') >= 0 || ua.indexOf('macintosh') >= 0) {
    const array = /os ([\d_]+)/.exec(ua);
    return {
      os: {
        device: IPAD,
        family: IOS,
        version: array && array[1] ? array[1].split('_').join('.') : '',
      },
    };
  }

  if (ua.indexOf('android') >= 0) {
    const array = /android ([\d¥.]+)/.exec(ua);
    return {
      os: {
        device: ANDROID,
        family: ANDROID,
        version: array && array[1] ? array[1] : '',
      },
    };
  }

  return {
    ua: userAgent,
    os: {
      device: 'unknown device',
      family: '',
      version: '',
    },
  };
};

// バージョン番号をメジャー、マイナーまでチェックする
const checkVersion = (device, platform) => {
  const { version } = platform.os;
  const arr = version.split('.');
  const ver = {
    major: arr && arr[0] ? arr[0] : 0,
    minor: arr && arr[1] ? arr[1] : 0,
    revision: arr && arr[2] ? arr[2] : 0,
    build: arr && arr[3] ? arr[3] : 0,
  };
  const v = Number(`${ver.major}.${ver.minor}`);
  switch (device) {
    case IOS: {
      return v >= IOS_SUPPORT_VERSION;
    }
    default: {
      return v >= ANDROID_SUPPORT_VERSION;
    }
  }
};

export const checkCompatible = () => {
  const platform = parse(window.navigator.userAgent);
  const { screen, innerWidth, innerHeight } = window;
  const { width, height } = screen;
  const isPortrait = innerWidth < innerHeight;
  const isSupportedIOSVersion =
    platform.os.family === IOS && checkVersion(IOS, platform);
  const isSupportedAndroidVersion =
    platform.os.family === ANDROID && checkVersion(ANDROID, platform);
  const isLikePCP = isPortrait && width >= 768 && height >= 1024;
  const isLikePCL = !isPortrait && width >= 1024 && height >= 768;
  const isLikePC = isLikePCP || isLikePCL || platform.os.device === IPAD;
  const isPC =
    (platform.os.family !== ANDROID && platform.os.family !== IOS) || isLikePC;
  const isSupportedDeviceVersion =
    isSupportedIOSVersion || isSupportedAndroidVersion || isPC;
  const isOverHightLimit = innerHeight < MIN_HEIGHT;
  const isIOS = platform.os.family === IOS;
  const isAndroid = platform.os.family === ANDROID;
  const compatible = {
    width,
    height,
    innerWidth,
    innerHeight,
    isPortrait,
    isPC,
    isIOS,
    isAndroid,
    isOverHightLimit,
    isSupportedIOSVersion,
    isSupportedAndroidVersion,
    isSupportedDeviceVersion,
  };
  return compatible;
};

export const createSortColumns = (oldSortcolumns, column, firstSort) => {
  const clickSortColumns =
    (oldSortcolumns && oldSortcolumns.filter(sort => sort.column === column)) ||
    [];
  const order = firstSort === 'A' || firstSort === 'D' ? firstSort : 'A';
  const newClickSortcolumns =
    clickSortColumns.length > 0
      ? { column, order: clickSortColumns[0].order === 'D' ? 'A' : 'D' }
      : { column, order };
  return [newClickSortcolumns];
};

export const isFile = obj => toString.call(obj) === '[object File]';

export const showToast = (message, bgColor) =>
  toast(message, {
    position: 'button-right',
    style: {
      background: bgColor || 'rgb(87, 179, 125, 0.9)',
      color: '#fff',
      opacity: '0.2',
    },
  });

export const showErrorToast = message =>
  showToast(message, 'rgba(226, 66, 66, 0.9)');

// LocalStorage登録（値がなければ削除）
export const saveLocalStorage = (key, value) => {
  if (value) {
    window.localStorage.setItem(key, value);
  } else {
    window.localStorage.removeItem(key);
  }
};

// LocalStorage読み込み
export const loadLocalStorage = key => window.localStorage.getItem(key);

// SessionStorage登録（値がなければ削除）
export const saveSessionStorage = (key, value) => {
  if (value) {
    window.sessionStorage.setItem(key, value);
  } else {
    window.sessionStorage.removeItem(key);
  }
};

// SessionStorage読み込み
export const loadSessionStorage = key => window.sessionStorage.getItem(key);

// かん助へのURLフォーマット
export const convertCansukeFormat = (result, url, recorddt, workername) => {
  const list = url
    ? [
        {
          url,
          recorddt,
          workername,
        },
      ]
    : [];
  const message = {
    result,
    imageList: list,
  };
  return message;
};

// かん助へ終了通知
export function postCloseMessageForCansuke() {
  window.opener.postMessage(
    JSON.stringify(convertCansukeFormat(CANSUKE_RESULT.close)),
    cansuke,
  );
}

// かん助へのURL送信
export const postMessageForCansuke = message => {
  window.removeEventListener('beforeunload', postCloseMessageForCansuke);
  window.opener.postMessage(JSON.stringify(message), cansuke);
  window.close();
};

/* eslint-disable */
/** NotificationAPIの通知許可取得 */
export const requestNotificationPermission = () => {
  if ('Notification' in window) {
    const { permission } = Notification;
    if (permission === 'denied' || permission === 'granted') {
      return;
    }
    Notification.requestPermission();
  }
};
/** NotificationAPI実施 */
export const notifyRemoteCall = params => {
  const { title = '', body = '', tag = '' } = params;
  const options = { body, tag };
  const notification = new Notification(title, options);
  notification.onclick = () => {
    // if (link) {
    //   window.open(link, '_blank');
    // } else {
    window.focus();
    // }
  };

  // 古いChromeなどは自動で閉じないためタイマー設定する
  setTimeout(() => {
    notification.close();
  }, 5000);
};
/* eslint-enable */

/**
 * Fileをbase64に変換し返す
 * @param {File} file base64に変換するFile（もしくはBlob）
 * @returns Promise
 */
export const convertToBase64 = file => {
  const promise = new Promise((resolve, reject) => {
    const reader = new window.FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
  return promise;
};

// eslint-disable-next-line no-promise-executor-return
export const sleep = ms => new Promise(res => setTimeout(res, ms));

/**
 * 取得した全階層のタグをフラットな形にして返却する
 * @param tags APIから取得した全階層のタグ
 * @returns flatTags 形式[[1階層目, 2階層目, ...],[1階層目, ...],...]
 */
export const getFlatTags = tags => {
  let flatTags = [];
  tags.forEach(tag => {
    // 階層ごとの処理
    const { depth, data: tagDepthData } = tag;
    // depth が null または tagDepthData が null であれば処理をスキップ
    // eslint-disable-next-line no-eq-null
    if (depth == null || tagDepthData == null) {
      return;
    }
    if (depth === 1) {
      // 1階層目の処理
      flatTags = tagDepthData.map(({ id, name }) => [{ id, name }]);
    } else {
      // 2階層目以降の処理
      // 親IDを重複なく抽出し、親ID単位に処理を行う
      const parentIds = Array.from(
        new Set(tagDepthData.map(({ parentId }) => parentId)),
      );
      parentIds.forEach(parentId => {
        // 該当の親IDを持つ表示配列のindexを取得(子データを差し込むため)
        const workIndex = flatTags.findIndex(
          item => item.length === depth - 1 && item[depth - 2].id === parentId,
        );
        // 自階層のタグデータで該当親IDを持つデータのみの子データを作成する(形式は[...親たち, 子])
        const children = tagDepthData
          .filter(data => data.parentId === parentId)
          .map(data =>
            flatTags[workIndex].concat([{ id: data.id, name: data.name }]),
          );
        // 表示配列の子データを挿入する
        flatTags.splice(workIndex + 1, 0, ...children);
      });
    }
  });
  return flatTags;
};

/**
 * 絞り込み選択用のタグを返却する
 * @param allDepthTags 階層タグ配列
 * @param param 選択済みタグ情報（オブジェクト{ tagId, name }の配列形式）
 * @returns tags selectOptions.tagsに設定可能な形式で返却
 */
export const getEnableTags = (allDepthTags, params) => {
  const tags = allDepthTags.reduce((accumulator, { depth, data }) => {
    const filterdData =
      depth === 1
        ? data
        : data.filter(
            ({ parentId }) =>
              (params[depth - 2] && parentId === params[depth - 2].tagId) ||
              false,
          );
    const depthData = filterdData.length > 0 ? { [depth]: filterdData } : {};
    const result = { ...accumulator, ...depthData };
    return result;
  }, {});
  return tags;
};
